var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M350,0C157.1,0,0.6,156.8,0.6,350S157.1,700,350,700s349.4-156.8,349.4-350S542.9,0,350,0z M350,628 C196.9,628,72.6,503.4,72.6,350.1C72.6,196.8,197,72.2,350,72.2c153.1,0,277.4,124.6,277.4,277.9S503.1,628,350,628z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.4,252c0,24.7-20.1,44.8-44.8,44.8c-24.7,0-44.8-20.1-44.8-44.8s20.1-44.8,44.8-44.8 C289.4,207.2,309.4,227.3,309.4,252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.3,252c0,24.7-20.1,44.8-44.8,44.8c-24.7,0-44.8-20.1-44.8-44.8s20.1-44.8,44.8-44.8 C462.2,207.2,482.3,227.3,482.3,252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.6,487.2c10.5-10.5,7-25.2-6.3-32.9c-42.7-23.8-263.9-23.8-306.5,0c-14,7.7-16.8,22.4-6.3,32.9 C206.5,497,508.2,496.3,516.6,487.2L516.6,487.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoso);
export default __webpack_public_path__ + "static/media/soso.fa92ae542dd3c1e8738fd99c2deb89ef.svg";
export { ForwardRef as ReactComponent };